import { render, staticRenderFns } from "./SohState.vue?vue&type=template&id=451cd33e&scoped=true&"
import script from "./SohState.vue?vue&type=script&lang=js&"
export * from "./SohState.vue?vue&type=script&lang=js&"
import style0 from "./SohState.vue?vue&type=style&index=0&id=451cd33e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451cd33e",
  null
  
)

export default component.exports